<div class="container-fluid mt-3">
  <div class="row">
    @if (environment.structural || (!environment.people && !environment.structural && !environment.traffic)) {
    <div class="col-sm-4 col-12 mt-2">
      <mat-card [routerLink]="'/infrastructure/structural-health'" class="shadow-card">
        <mat-card-header>
          <mat-card-title>
            <div class="d-flex align-item-center"><mat-icon>engineering</mat-icon>Structural Health
            </div>
          </mat-card-title>
          <mat-card-subtitle>Structural Health Overview</mat-card-subtitle>
        </mat-card-header>
        <img src="../../../assets/img/structural_health_icon.png" class="view-card-img">
        <mat-card-content class="mt-2">
          Structural Health overview and road damage analysis, detecting HIGH, MEDIUM and LOW severities of
          road damage issues.
        </mat-card-content>
        <mat-card-actions class="d-flex justify-content-end">
          <a mat-raised-button [routerLink]="'/infrastructure/structural-health'">View</a>
        </mat-card-actions>
      </mat-card>
    </div>
    }

    @if (environment.people || (!environment.people && !environment.structural && !environment.traffic)) {
    <div class="col-sm-4 col-12 mt-2">
      <mat-card [routerLink]="'/stations/people'" class="shadow-card">
        <mat-card-header>
          <mat-card-title class="text-center">
            <div class="d-flex align-item-center gap-3"><mat-icon>people</mat-icon>People Movement</div>
          </mat-card-title>
          <mat-card-subtitle>People Movement Overview</mat-card-subtitle>
        </mat-card-header>
        <img src="../../../assets/img/people_movement_icon.png" class="view-card-img">
        <mat-card-content class="mt-2">
          The Monitoring of people movement in airports, stations and others using thermal cameras.
        </mat-card-content>
        <mat-card-actions class="d-flex justify-content-end">
          <a mat-raised-button [routerLink]="'/stations/people'">View</a>
        </mat-card-actions>
      </mat-card>
    </div>
    }

    @if (environment.traffic || (!environment.people && !environment.structural && !environment.traffic) ||
    (environment.traffic && environment.structural)) {
    <div class="col-sm-4 col-12 mt-2">
      <mat-card [routerLink]="'/infrastructure/traffic-monitoring'" class="shadow-card">
        <mat-card-header>
          <mat-card-title class="text-center">
            <div class="d-flex align-item-center gap-3"><mat-icon>traffic</mat-icon>Traffic Monitoring</div>
          </mat-card-title>
          <mat-card-subtitle>Traffic Monitoring Overview</mat-card-subtitle>
        </mat-card-header>
        <img src="../../../assets/img/car_violation.png" class="view-card-img">
        <mat-card-content class="d-flex mt-2">
          Traffic Monitoring Analysis covering a range of analysis from traffic speed, estimated co2 emissions
          and more.
        </mat-card-content>
        <mat-card-actions class="d-flex justify-content-end">
          <a mat-raised-button [routerLink]="'/infrastructure/traffic-monitoring'">View</a>
        </mat-card-actions>
      </mat-card>
    </div>
    }
  </div>
</div>